import React from "react";

import { TFunction } from "i18next";
import { Grid } from "@mui/material";

import { BaseLabel, Button, GeneralInput, TextLink } from "components";

import { DivEmail, DivLogo, LinkContainer } from "../styles";
import { TextForgotPasswordInfo } from "./styles";

export const validEmail = (email: string): boolean => {
  if (email.length > 320) {
    return false;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+(\.[^\s@]+){1,4}$/;
  return emailRegex.test(email);
};

export const ForgotPasswordStepOne = (
  email: string,
  setEmail: React.Dispatch<React.SetStateAction<string>>,

  handleSubmit: (e: any) => Promise<void>,
  error: boolean,
  setError: React.Dispatch<React.SetStateAction<boolean>>,

  navigate?: any,
  t?: TFunction,
) => {
  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid alignContent="center">
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              marginTop: "310px",
            }}
          >
            <DivLogo>
              <BaseLabel
                fontSize="18px"
                fontWeight="700"
                children={t?.("auth.forgotPassword.title") ?? "Recuperação de senha"}
              />
              <BaseLabel
                fontSize="14px"
                fontWeight="500"
                marginTop="13px"
                children={t?.("auth.forgotPassword.description") ?? "Informe o e-mail que você utiliza para acessar sua conta."}
              />
            </DivLogo>
            <DivEmail marginTop="27px">
              <GeneralInput
                label={t?.("auth.forgotPassword.yourEmail") ?? "Seu e-mail"}
                name={"email"}
                onChange={setEmail}
                value={email}
                error={error}
                setError={setError}
              />
            </DivEmail>
            <Button
              id="sign-in_button"
              marginBottom="16px"
              type="submit"
              onClick={(e: any) => handleSubmit(e)}
            >
              {t?.("common.continue") ?? "Continuar"}
            </Button>
          </Grid>
        </Grid>
      </form>
      <LinkContainer type="submit" onClick={() => navigate("/")}>
        <TextLink>{t?.("auth.backToLogin") ?? "Voltar ao login"}</TextLink>
      </LinkContainer>
    </>
  );
};

export const ForgotPasswordStepTwo = (navigate: any, navigateTo: string, t?: TFunction) => {
  return (
    <>
      <form>
        <Grid alignContent="center">
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: "390px",
              marginTop: "315px",
            }}
          >
            <TextForgotPasswordInfo>
              <BaseLabel
                fontSize="18px"
                fontWeight="700"
                children={t?.("auth.forgotPassword.checkEmail") ?? "Verifique seu e-mail"}
                marginBottom="0px"
                marginTop="0px"
                marginLeft="0px"
                marginRight="0px"
              />
            </TextForgotPasswordInfo>
            <TextForgotPasswordInfo paddingTop="29px">
              <BaseLabel
                fontSize="14px"
                fontWeight="500"
                marginBottom="0px"
                marginTop="0px"
                marginLeft="0px"
                marginRight="0px"
                children={t?.("auth.forgotPassword.instructionsSent") ?? "Enviamos para você as instruções para a criação de uma nova senha."}
              />
            </TextForgotPasswordInfo>
            <TextForgotPasswordInfo paddingTop="28px">
              <BaseLabel
                fontSize="14px"
                fontWeight="500"
                marginBottom="0px"
                marginTop="0px"
                marginLeft="0px"
                marginRight="0px"
                children={t?.("auth.forgotPassword.notReceived") ?? "Caso não tenha recebido a mensagem, repita o procedimento."}
              />
            </TextForgotPasswordInfo>
            <TextForgotPasswordInfo paddingTop="27px">
              <BaseLabel
                fontSize="14px"
                fontWeight="500"
                marginBottom="0px"
                marginTop="0px"
                marginLeft="0px"
                marginRight="0px"
                children={t?.("auth.forgotPassword.contactSupport") ?? "Se o problema persistir, entre contato com nosso suporte técnico."}
              />
            </TextForgotPasswordInfo>
            <TextForgotPasswordInfo paddingTop="24px">

              <Button
                id="sign-in_button"
                onClick={() => navigate(navigateTo)}
              >
                {t?.("auth.backToLogin") ?? "Voltar ao login"}
              </Button>
            </TextForgotPasswordInfo>
          </Grid>
        </Grid>
      </form>
    </>
  );
};
